<template>
    <div aria-hidden="true" aria-labelledby="informLabel" class="modal fade" id="div-register-passkey-modal" tabindex="-1">
        <div class="modal-dialog">
            <div class="modal-content rounded-lg">
                <div class="modal-header border-bottom-0 position-relative">
                    <button aria-label="Close" class="close modal-close-btn" data-dismiss="modal" type="button" @click="closeModal()">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body pt-0 pl-4 pr-4">
                    <RegisterPasskeyContentCommon/>
                </div>
                <div class="modal-footer border-top-0 pt-0">
                    <div class="row w-100 justify-content-center">
                        <div class="col-sm-6 col-md-5 col-xl-4 mb-2">
                            <button class="btn btn-sm btn-primary w-100" @click="registerMorePasskey()">
                                <span>パスキーを登録する</span>
                            </button>
                        </div>
                        <div class="col-sm-6 col-md-5 col-xl-4 mb-2">
                            <button class="btn btn-sm btn-default w-100" @click="closeModal()">
                                <span>後で設定する</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import RegisterPasskeyContentCommon from '@/views/passkey/RegisterPasskeyContentCommon'
    import IConstants from '@/common/constants/IConstants';
    import ServiceUtils from "@/common/utils/ServiceUtils";
    import ModalPlugin from "@/common/plugins/ModalPlugin.js";
    import $ from "jquery";

    export default {
        name: "RegisterPasskeyModal",
        mixins: [],
        components: {RegisterPasskeyContentCommon},
        data() {
            return {}
        },
        validations() {
            return {}
        },
        computed: {},
        mounted() {
            this.listenEvents();
        },
        methods: {
            listenEvents() {
                ModalPlugin.EventBus.$on(this.IConstants.EVENT_NAME.SHOW_REGISTER_PASSKEY_MODAL, (params) => {
                    $('#div-register-passkey-modal').modal({backdrop: 'static', keyboard: false});
                    this.params = params;
                    $("#div-register-passkey-modal").modal("show");
                });
                ModalPlugin.EventBus.$on(this.IConstants.EVENT_NAME.RETRY_REGISTER_PASSKEY_MODAL_RESULT, (params) => {
                    if (String(params.retry) === 'true') this.registerMorePasskey()
                    else this.$modal.reloadRegisteredPasskeys();
                });
            },
            async registerMorePasskey() {
                await this.closeModal();
                if (ServiceUtils.isFidoAuthenticateUnsupported()) return this.$modal.showFidoAuthenticateUnsupported()

                this.$service
                    .getService(IConstants.SERVICE_NAME.FIDO)
                    .initRegisterPasskey()
                    .then(async (res) => {
                        if (res.errorMessage) return this.finishRegisterPasskeyModal(false)

                        let credential = await navigator.credentials.create(ServiceUtils.genMakeCredentialRequestV1(res))
                        if (!credential) return this.finishRegisterPasskeyModal(false);

                        let requestPayload = {
                            customerId: res.customerId,
                            fidoUserId: res.fidoUserId,
                            fidoRegistrationId: res.fidoRegistrationId,
                            fidoRegistrationChallengeId: res.fidoRegistrationChallengeId,
                            authProviderName: ServiceUtils.detectSelectedAuthenticator(credential),
                            w3cMakeCredentialResponse: ServiceUtils.genW3cMakeCredentialResponse(credential)
                        }
                        this.$service
                            .getService(IConstants.SERVICE_NAME.FIDO)
                            .registerPasskey(requestPayload, {headers: {'Content-Type': 'application/json'}})
                            .then((res) => {
                                this.finishRegisterPasskeyModal(!res.errorMessage)
                            })
                    })
                    .catch((e) => {
                        if (ServiceUtils.isUserCancelOrTimeoutPasskeyAction(e)) return;
                        if (ServiceUtils.isDeviceNotSupportPasskey(e)) return this.$modal.showFidoAuthenticateUnsupported();
                        this.finishRegisterPasskeyModal(false)
                    })
                    .finally(() => {
                    })
            },
            finishRegisterPasskeyModal(result) {
                const params = {result: result};
                this.$modal.showRegisterPasskeyModalResult(params);
            },
            async closeModal() {
                await ServiceUtils.waitModalFullyHidden($('#div-register-passkey-modal'));
            },
        }
    }
</script>

<style scoped>
    .modal-dialog {
        max-width: 800px;
    }
</style>
